import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  removeNoteFromProposal,
  removeUpdatingNoteAdded,
  setNoteUpdatingInProposal,
  updatingNoteAdded,
} from "../../actions/proposal";
import { openModal } from "../../actions/ui";
import { images } from "../../constants";
import ModalProposal from "../Modals/ModalProposal";
import "./DescriptionCard.scss";
import ProposalNoteSelectedEditing from "./ProposalNoteSelectedEditing";

const DescriptionCard = ({ note }) => {
  const dispatch = useDispatch();

  const { modalOpen } = useSelector((state) => state.ui);
  const { updatingNote } = useSelector((state) => state.proposals);

  const handleDeleteNote = () => {
    dispatch(removeNoteFromProposal());
  };
  const handleEditNote = () => {
    dispatch(openModal());
    dispatch(updatingNoteAdded());
    dispatch(setNoteUpdatingInProposal(note));
  };

  return (
    <div className="card-description">
      <div className="card-description__wrapper">
        <div className="card-description__heading">
          <button onClick={handleDeleteNote}>
            <img src={images.IconDelete} alt="" />
          </button>

          <button onClick={handleEditNote}>
            <img src={images.IconEdit} alt="" />
          </button>
        </div>
        <p className="paragraph-gray-reg-16">{note.description}</p>
      </div>
      {modalOpen && updatingNote && (
        <ModalProposal clean={removeUpdatingNoteAdded}>
          <ProposalNoteSelectedEditing />
        </ModalProposal>
      )}
    </div>
  );
};

export default DescriptionCard;
